import(/* webpackMode: "eager" */ "/mnt/volume-nbg1-1/apps/aseanlex/frontend/src/app/login/page.tsx");
